import { render } from "./control-size.vue?vue&type=template&id=0a302be7"
import script from "./control-size.vue?vue&type=script&lang=js"
export * from "./control-size.vue?vue&type=script&lang=js"

import "./control-size.vue?vue&type=style&index=0&id=0a302be7&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__